import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import { DEFAULT_LANGUAGE_CODE, I18N_DEFAULT_NAMESPACE } from 'constants/localization';

i18n.use(initReactI18next).init({
  lng: DEFAULT_LANGUAGE_CODE,
  fallbackLng: DEFAULT_LANGUAGE_CODE,
  ns: [I18N_DEFAULT_NAMESPACE],
  defaultNS: I18N_DEFAULT_NAMESPACE,
  keySeparator: false,
  nsSeparator: false,
  returnNull: false,
  interpolation: {
    escapeValue: true,
  },
  react: {
    bindI18nStore: 'added',
    useSuspense: false,
  },
});

export default i18n;
